import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import { AppPermissions, ITag, useHasPermission } from '../../../../core';

const CreateForm: React.FunctionComponent<{
  onSubmit: (data: ITag) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: ITag;
  error?: string;
  onDelete: (id?: string) => void;
}> = (props) => {
  const canDeleteTag = useHasPermission(AppPermissions.DeleteTag);
  const canCreateTag = useHasPermission(AppPermissions.CreateTag);
  const canUpdateTag = useHasPermission(AppPermissions.UpdateTag);
  const [isDeleteModalOpen, setDeleteModalOpen] = React.useState<boolean>(
    false
  );
  const { control, handleSubmit, errors } = useForm<ITag>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });

  const onDelete = () => {
    setDeleteModalOpen(true);
  };

  const onCancelDelete = () => {
    setDeleteModalOpen(false);
  };

  const renderDeleteConfirm = () => {
    return isDeleteModalOpen ? (
      <>
        <div
          className="modal fade show in"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
            <div className="modal-content rounded-0">
              <div className="modal-body text-center">
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <p>You are about to delete the Tag {props.data?.name}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-auto mr-auto">
                      <button
                        type="button"
                        className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
                        onClick={onCancelDelete}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-auto">
                      <button
                        type="button"
                        className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
                        onClick={() => {
                          props.onDelete(props.data?._id);
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </>
    ) : (
      <></>
    );
  };

  const renderNameTextBox = () => {
    return (
      <div className="col-lg-12 col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Tag Name In English</label>
          <Controller
            control={control}
            rules={{ required: 'Name is required' }}
            name="name"
            defaultValue={props.data?.name}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Name"
                name={name}
                value={value}
                onChange={onChange}
                id="name"
              />
            )}
          />
          <ErrorMessage>{errors.name?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          {props.data && canDeleteTag && (
            <button
              type="button"
              className="btn btn-outline-gray py-2 font-weight-semibold font-normal px-4 mr-1"
              onClick={onDelete}
            >
              <i className="icon-bin-fill cursor-pointer align-self-center font-lg text-gray-700"></i>
            </button>
          )}
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          {canCreateTag && !props.data?._id && (
            <button
              type="submit"
              className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
              disabled={props.isSubmitting}
            >
              Create
            </button>
          )}
          {props.data && canUpdateTag && (
            <button
              type="submit"
              className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
              disabled={props.isSubmitting}
            >
              Update
            </button>
          )}
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">
          {props.data && props.data ? 'Update ' : 'Create '} Tag
        </h4>
        <div className="row gutter-10">
          {renderNameTextBox()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
          {renderDeleteConfirm()}
        </div>
      </div>
    </form>
  );
};

export default CreateForm;
